<template lang="html">
  <div v-show="configVisible">
    <div v-if="!visible" class="todo" :class="{leftSwipe: left, dark: darkmode}">
      <AveBigIcon class="offscreenLeft" icon="done"/>
      <AveBigIcon class="offscreenRight" icon="edit"/>
      <div
      class="wrapper"
      :class="{transition: !swiping, focussed:focus}"
      :style="{ transform: `translateX(${transformX}px)`}"
      @mousedown="swipeStart"
      @touchstart="swipeStart"
      >
        <div class="contentWrapper">
          <AveBigIcon
          class="taskIcon"
          :class="{dark: darkmode, done}"
          :icon="icon"
          :icon-type="iconType"
          @click.native="handleTracking"
          />
          <section class="description">
            <h3 class="taskHead">{{title}}</h3>
            <p class="text">{{`${formatDoneTime}h of ${formatTrackedTime}h done, ${creationDate}`}}<br>{{label}}</p>
          </section>
        </div>
      </div>
    </div>
    <AveAddEditToDo
    :current-task="title"
    :current-time="formatedEditTime"
    :current-donetime="formatedDonetime"
    :current-label="label"
    :darkmode="darkmode"
    :error-type="errorType"
    :visible="visible"
    label="Delete"
    type="edit"
    @hideDelete="deleteTodo"
    @emitInputs="editTodo"
    />
  </div>
</template>

<script>
import AveBigIcon from '@/components/AveBigIcon.vue';
import AveAddEditToDo from '@/components/AveAddEditToDo.vue';

export default {
  components: {
    AveBigIcon,
    AveAddEditToDo,
  },

  computed: {
    configVisible() {
      if (this.done === 1) {
        return !this.$store.state.hideFinishedTodos;
      }
      return true;
    },
    formatDoneTime() {
      if (this.id === this.$store.state.currentTrackingId) {
        // this.donetime = this.$store.state.currentTrackingDoneTime;
        return this.formatTime(this.$store.state.currentTrackingDoneTime);
      }
      return this.formatTime(this.donetime);
    },
    formatTrackedTime() {
      return this.formatTime(this.time);
    },
    formatedDonetime() {
      return this.formatInputTime(this.donetime);
    },
    formatedEditTime() {
      return this.formatInputTime(this.time);
    },
    icon() {
      // Das Icon wird geändert, wenn die Icon ID gleich der Tracking ID ist
      if (this.id === this.$store.state.currentTrackingId) {
        return 'timetracking';
      }
      return 'task';
    },
    iconType() {
      if (this.done) {
        return 'positive';
      }
      return 'normal';
    },
  },

  data() {
    return {
      focus: false,
      left: false,
      maxSwipeDistance: 0,
      startX: 0,
      swiping: false,
      transformX: 0,
      visible: false,
    };
  },

  props: {
    creationDate: {
      type: String,
      default: '01.01.10000',
    },
    darkmode: Boolean,
    done: {
      type: Number,
    },
    donetime: {
      type: Number,
      default: 0,
    },
    errorType: String,
    title: {
      type: String,
      default: 'Uups',
    },
    id: {
      type: Number,
    },
    label: {
      type: String,
      default: '',
    },
    projectId: {
      type: Number,
      default: 0,
    },
    time: {
      type: Number,
      default: 0,
    },
    tracking: {
      type: Boolean,
    },
  },
  methods: {

    deleteTodo() {
      this.visible = !this.visible;
      // console.log('delete');
      const currenttodo = this.id;
      this.$emit('deleteTodo', currenttodo);
    },

    editTodo(data) {
      this.visible = !this.visible;
      // console.log(`data income: ${data}`);
      const changes = {
        title: this.title, time: this.time, donetime: this.donetime, label: this.label, id: this.id,
      };
      // console.log(`data income: ${changes}`);
      if (this.title !== data.title && data.title !== '') {
        changes.title = data.title;
      }
      if (this.time !== data.time && !Number.isNaN(data.time)) {
        changes.time = data.time;
      }
      if (this.label !== data.label && data.label !== '#') {
        changes.label = data.label;
      }
      if (!Number.isNaN(data.donetime)) {
        changes.donetime += data.donetime;
      }
      // console.log(`data income: ${changes}`);
      this.$emit('editTodo', changes);
    },

    formatInputTime(milli) {
      const hours = milli / 3600000;
      const totalHours = Math.floor(hours);
      const h = totalHours > 9 ? totalHours : `0${totalHours}`;

      const minutes = (hours - totalHours) * 60;
      const totalMinutes = Math.floor(minutes);
      const m = totalMinutes > 9 ? totalMinutes : `0${totalMinutes}`;

      if (minutes === 0) {
        return `${h}`;
      }
      return `${h}:${m}, ${h} ${m}`;
    },


    formatTime(input) {
      const milli = input;
      // const MILLITOHOURS = 3600000;
      // const MILLITOMINUTES = 60000;
      // const MILLITOSECONDS = 1000;
      const hours = milli / 3600000;
      const totalHours = Math.floor(hours);
      const h = totalHours > 9 ? totalHours : `0${totalHours}`;

      const minutes = (hours - totalHours) * 60;
      const totalMinutes = Math.floor(minutes);
      const m = totalMinutes > 9 ? totalMinutes : `0${totalMinutes}`;

      const seconds = (minutes - totalMinutes) * 60;
      const totalSeconds = Math.floor(seconds);
      const s = totalSeconds > 9 ? totalSeconds : `0${totalSeconds}`;
      return `${h}:${m}:${s}`;
    },

    handleTracking() {
      // Wenn das Todo Done ist kann man es nicht tracken!
      if (this.done === 1) {
        return;
      }
      if (this.$store.state.currentTrackingId === this.id) {
        // Never change Prop
        // this.donetime = this.$store.state.currentTrackingDoneTime;
        this.$store.dispatch('stopTracking');
        // this.$emit('changestatus', { id: this.id, donetime: this.$store.state.currentTrackingDoneTime });
      } else {
        // Versuch es vom Todo aus zu triggern.
        // TrckingData Object erstellen TrackingTitle, TrackingID, TrackingdoneTime
        const trackingData = {
          trackingTitle: this.title,
          trackingId: this.id,
          trackingDoneTime: this.donetime,
          startTime: Date.now(),
          trackingTime: this.time,
        };
        this.$store.dispatch('startTracking', trackingData);
      }
    },
    swipeStart(e) {
      // this.startX = e.clientX;
      this.swiping = true;
      this.focus = true;
      this.maxSwipeDistance = e.currentTarget.getBoundingClientRect().width;

      this.startX = e.type === 'touchstart' ? e.changedTouches[0].clientX : e.clientX; // abspeichern, wo der Swipe angefangen hat

      if (e.type === 'touchstart') {
        window.addEventListener('touchmove', this.swipeUpdate, false);
        window.addEventListener('touchend', this.swipeEnd, false);
      } else {
        window.addEventListener('mousemove', this.swipeUpdate, false);
        window.addEventListener('mouseup', this.swipeEnd, false);
      }
    },

    swipeUpdate(e) {
      const currentX = e.type === 'touchmove' ? e.changedTouches[0].clientX : e.clientX;

      const distance = currentX - this.startX; // der Abstand, um den geswiped wurde in px

      // const distance = e.clientX - this.startX;
      if (Math.sign(distance) < 0) {
        this.left = true;
      } else {
        this.left = false;
      }
      this.transformX = distance;
    },

    swipeEnd(e) {
      const currentX = e.type === 'touchend' ? e.changedTouches[0].clientX : e.clientX;
      const finalDistance = currentX - this.startX;
      let direction = Math.sign(finalDistance);
      if (direction > 0) {
        direction = 'right';
      } else {
        direction = 'left';
      }

      window.removeEventListener('mousemove', this.swipeUpdate, false);
      window.removeEventListener('touchmove', this.swipeUpdate, false);
      window.removeEventListener('mouseup', this.swipeEnd, false);
      window.removeEventListener('touchend', this.swipeEnd, false);

      this.swiping = false;
      if (Math.abs(finalDistance) > 60) {
        if (direction === 'right') {
          // console.log('Swiped to the right');
          const currenttodo = this.id;
          this.$emit('done', currenttodo);
          // Make it Done
        } else {
          // console.log('Swiped to the left');
          // Edit the Task
          // this.$emit('edit');
          this.visible = !this.visible;
        }
        this.transformX = 0;
      } else {
        this.transformX = 0;
      }
      this.focus = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '../assets/styles/colors.styl'
@require '../assets/styles/styles.styl'
@require '../assets/styles/base.styl'
h3
  &.taskHead
    margin: 0
    margin-bottom: 2px

p
  margin 0

  &.text
    margin: 0
    font-size: 11px
    font-weight: 600
    line-height: 152.8%

.todo
  background-color: $positive
  overflow: hidden
  position: relative
  margin-bottom $marginBottom - 10px

  :hover
    cursor: pointer

  &.leftSwipe
    background-color: $negative

  &.dark
    .wrapper
      background-color: $normal
      color $darkmodeWhite

.wrapper
  position relative
  left -10px
  display flex
  align-items: center
  width calc(100% + 20px)
  background-color: $white
  box-shadow: 0 0 0 3pt rgba(67, 67, 67, 0.67);
  border-radius 7px

  &.transition
    // border-radius none
    transition: all 200ms ease

.contentWrapper
  display flex
  align-items center
  width $contentWrapperWidth
  padding-top 7px
  padding-bottom 7px
  margin auto

.offscreenLeft
  position: absolute;
  top 50%
  transform: translateY(-50%);
  left: 13px

.offscreenRight
  position: absolute;
  top 50%
  transform: translateY(-50%);
  right: 13px

.taskIcon
  position relative
  left 10px
  &.done
    color: $positive

.description
  position relative
  left 23px

.add-edit-todo
  width $contentWrapperWidth
  padding-top $marginBottom
  margin auto
</style>
